import { Observable } from 'rxjs';
import { ApiListResult } from '@capturum/auth';
import { MapItem } from '@capturum/ui/api';

export function responseData<T = any>(source: Observable<{ data: T }>): Observable<T> {
  return new Observable(subscriber => {
    source.subscribe({
      next(value: {data: T}): void {
        if (value) {
          subscriber.next(value.data);
        }

        subscriber.complete();
      },
      error(error): void {
        subscriber.error(error);
      }
    });
  });
}

export function apiListResultToMapItem(result: ApiListResult, valueProperty: string = 'value', labelProperty: string = 'label'): MapItem[] {
  return result.data.map((item) => {
    return {
      label: item[labelProperty],
      value: item[valueProperty],
    };
  });
}

export function toMapItems(source: Observable<ApiListResult>, valueProperty: string = 'key', labelProperty: string = 'label'): Observable<MapItem[]> {
  return new Observable(subscriber => {
    source.subscribe({
      next(value: ApiListResult): void {
        if (value !== undefined && value !== null) {
          subscriber.next(apiListResultToMapItem(value, valueProperty, labelProperty));
        }
      },
      error(error: any): void {
        subscriber.error(error);
      },
      complete(): void {
        subscriber.complete();
      },
    });
  });
}
